module.exports = __webpack_public_path__ + "img/video_lessons.6aa887d8.svg";